import { createFileRoute } from "@tanstack/react-router";
import { PriceBreakdownCoefficientsSettingsPage } from "../../../../../pages/organisation-page/organisation-settings-pages";

export const Route = createFileRoute("/_auth/_organisation/organisation/exports/price-breakdown-coefficients")({
  component: PriceBreakdownCoefficientsSettingsPage,
});
